
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15.5","cy":"10","r":"6.15","fill":"#999","stroke":"#fff","stroke-width":"1.3"}}),_c('circle',{attrs:{"cx":"11.5","cy":"10","r":"6.15","fill":"#999","stroke":"#fff","stroke-width":"1.3"}}),_c('circle',{attrs:{"cx":"7.5","cy":"10","r":"6.15","fill":"#999","stroke":"#fff","stroke-width":"1.3"}}),_c('path',{attrs:{"d":"M5 10l1.667 1.5L10 8.5","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    